import { render } from "./ServicesBlock.vue?vue&type=template&id=fba69352&scoped=true"
import script from "./ServicesBlock.vue?vue&type=script&lang=js"
export * from "./ServicesBlock.vue?vue&type=script&lang=js"

import "./ServicesBlock.vue?vue&type=style&index=0&id=fba69352&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fba69352"]])

export default __exports__